"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const user_session_service_1 = require("../../../shared/ts/services/user-session-service");
const spinner_1 = require("../../../shared/ts/components/spinner");
class App extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    async componentDidMount() {
        if (user_session_service_1.UserSessionService.userSession.isUserSignedIn()) {
            const user = user_session_service_1.UserSessionService.userSession.loadUserData();
            this.setState({
                user
            });
            this.notifyUserSignedIn();
        }
        else if (user_session_service_1.UserSessionService.userSession.isSignInPending()) {
            const user = await user_session_service_1.UserSessionService.userSession.handlePendingSignIn();
            window.history.replaceState({}, document.title, "/");
            this.setState({
                user
            });
            this.notifyUserSignedIn();
        }
        else {
            user_session_service_1.UserSessionService.userSession.redirectToSignIn();
        }
    }
    notifyUserSignedIn() {
        window.postMessage({
            origin: "com.ghostbrowser.blockstack.auth" /* BlockstackAuth */,
            type: 4 /* OnUserSignedIn */
        }, "*");
    }
    render() {
        const user = this.state.user;
        return (react_1.default.createElement("div", { className: "app" },
            react_1.default.createElement("div", { className: "app-body" },
                react_1.default.createElement("div", { className: "mr-3" },
                    react_1.default.createElement(spinner_1.Spinner, { size: 38 })),
                react_1.default.createElement("div", null, user
                    ? `${user.username} is signed in. Redirecting...`
                    : "Signing in..."))));
    }
}
exports.App = App;
